package com.tixforgigs.common.ui.pages.login


import com.tixforgigs.common.CommonBuildKonfig
import com.tixforgigs.common.core.enums.LoginMode
import com.tixforgigs.common.core.enums.MandarinInputType
import com.tixforgigs.common.core.enums.View
import com.tixforgigs.common.core.extensions.RoutingUtil.AppScope
import com.tixforgigs.common.core.extensions.RoutingUtil.routing
import com.tixforgigs.common.core.extensions.navigateTo
import com.tixforgigs.common.core.interfaces.StorefrontPage
import com.tixforgigs.common.core.models.ui.InputState
import com.tixforgigs.common.core.util.AuthUtil.login
import com.tixforgigs.common.core.util.AuthUtil.signup
import com.tixforgigs.common.core.util.InputUtil.emailRegex
import com.tixforgigs.common.core.util.TrackerUtil.pageView
import com.tixforgigs.common.ui.components.forms.fieldPanel
import com.tixforgigs.common.ui.components.forms.fieldsGapPanel
import com.tixforgigs.common.ui.components.icons.Icon
import com.tixforgigs.common.ui.components.mandarin.buttonsPanel
import com.tixforgigs.common.ui.components.mandarin.mandarinFilledButton
import com.tixforgigs.common.ui.components.mandarin.mandarinInput
import com.tixforgigs.common.ui.components.mandarin.mandarinTitle
import com.tixforgigs.common.ui.components.root.defaultTemplate
import com.tixforgigs.common.ui.components.structure.containerPanel
import com.tixforgigs.tarami.GlobalMessage.textPasswordForgot
import io.kvision.core.Cursor
import io.kvision.core.TextDecoration
import io.kvision.core.TextDecorationLine
import io.kvision.core.onClick
import io.kvision.event.clickFlow
import io.kvision.html.span
import io.kvision.material.ExperimentalMaterialApi
import io.kvision.material.tabs.primaryTab
import io.kvision.material.tabs.tabs
import io.kvision.panel.SimplePanel
import io.kvision.panel.simplePanel
import io.kvision.state.bind
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.flow.*
import kotlinx.coroutines.launch
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone.Companion.currentSystemDefault
import kotlinx.datetime.atTime
import kotlinx.datetime.toInstant
import kotlin.time.ExperimentalTime


/**
 * ## Login View
 *
 * A view for handling user login functionality.
 */
@OptIn(ExperimentalMaterialApi::class, ExperimentalTime::class)
class LoginView : SimplePanel(className = "xm-page xm-page-auth-login"), StorefrontPage {

  override val VIEW: View get() = View.LOGIN

  val mSelectedMode = MutableStateFlow(LoginMode.LOGIN)

  val mEmailInput =
    MutableStateFlow<InputState<String>>(
      InputState(
        CommonBuildKonfig.TEST_USER,
        CommonBuildKonfig.TEST_USER.matches(emailRegex)
      )
    )
  val mPasswordInput =
    MutableStateFlow<InputState<String>>(
      InputState(
        CommonBuildKonfig.TEST_PASS,
        CommonBuildKonfig.TEST_PASS.isNotEmpty()
      )
    )

  val mDateOfBirthInput = MutableStateFlow(
    InputState(
      runCatching { LocalDate.parse(CommonBuildKonfig.TEST_DOB) }.getOrNull(),
      if (CommonBuildKonfig.TEST_DOB.isNotEmpty()) CommonBuildKonfig.TEST else true
    )
  )
  val mGivenNameInput = MutableStateFlow<InputState<String>>(
    InputState(CommonBuildKonfig.TEST_GN, true)
  )
  val mFamilyNameInput = MutableStateFlow<InputState<String>>(
    InputState(CommonBuildKonfig.TEST_SN, true)
  )

  val inputsValid = combine(mSelectedMode, mEmailInput, mPasswordInput) { mode, email, password ->
    when (mode) {
      LoginMode.LOGIN -> email.isValid && password.isValid
      LoginMode.SIGNUP -> email.isValid && password.isValid
    }
  }.stateIn(MainScope(), SharingStarted.Eagerly, false)


  init {
    AppScope.launch {
      pageView()
    }

    defaultTemplate {
      containerPanel().bind(mSelectedMode) { selectedMode ->
//        genericBackButton(textBackToAccount(), View.EVENTS)
        mandarinTitle(selectedMode.title)
        tabs(activeTabIndex = selectedMode.index) {
          LoginMode.entries.forEach { mode ->
            primaryTab(
              text = mode.title,
              active = selectedMode == mode
            ).onClick {
              mSelectedMode.update { mode }
            }
          }
        }

        fieldsGapPanel {
          fieldPanel {
            mandarinInput(
              state = mEmailInput,
              inputType = MandarinInputType.EMAIL
            )
          }
          fieldPanel {
            mandarinInput(
              state = mPasswordInput,
              inputType = MandarinInputType.PASSWORD
            )
          }

          if (selectedMode == LoginMode.SIGNUP) {
            fieldPanel {
              mandarinInput(
                state = mGivenNameInput,
                inputType = MandarinInputType.FIRST_NAME
              )
            }
            fieldPanel {
              mandarinInput(
                state = mFamilyNameInput,
                inputType = MandarinInputType.LAST_NAME
              )
            }
            fieldPanel {
              mandarinInput(
                state = mDateOfBirthInput,
                inputType = MandarinInputType.BIRTHDATE,
                required = false
              )
            }
          }
        }

        if (selectedMode == LoginMode.LOGIN) {
          simplePanel() {
            span {
              textDecoration = TextDecoration(line = TextDecorationLine.UNDERLINE)
              cursor = Cursor.POINTER
              +textPasswordForgot()
            }.clickFlow.onEach {
              routing.navigateTo(View.FORGOT_PASSWORD)
            }.launchIn(MainScope())
          }
        }

        fieldsGapPanel {
          buttonsPanel {
            mandarinFilledButton(
              iconName = Icon.LOGIN,
              title = selectedMode.button,
              isEnabled = inputsValid
            ) {
              //todo: add trim() to all inputs
              when (selectedMode) {
                LoginMode.LOGIN -> {
                  login(
                    mEmailInput.value.inputValue.trim(),
                    mPasswordInput.value.inputValue.trim()
                  )
                }

                LoginMode.SIGNUP -> {
                  signup(
                    mEmailInput.value.inputValue.trim(),
                    mPasswordInput.value.inputValue.trim(),
                    mFamilyNameInput.value.inputValue.trim(),
                    mGivenNameInput.value.inputValue.trim(),
                    mDateOfBirthInput.value.inputValue?.atTime(hour = 12, minute = 0)?.toInstant(currentSystemDefault())
                    // TODO use LocalDate see: TASK-123
                  )
                }
              }
            }
          }
        }


      }
    }
  }
}
